/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTIcon} from '../../../../_metronic/helpers'
import NewTicketModal from '../Modal/NewTicketModal'
import {ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import usePaginationCounts from '../../../utils/hooks/usePaginationCounts'
import {BASE_URL} from '../../config'
import {useEffect, useState} from 'react'
import {getTicketDetailsById, ITicket, ITicketDetails} from '../_model'
import {useQuery} from 'react-query'
import axios from 'axios'
import {searchItems} from '../../../utils/helperFunction/_helper'
import ticketColumnList from './ticketColumnList'
import TableContent from '../../../utils/components/table-content/TableContent'
import TablePagination from '../../../utils/components/table-content/TablePagination'
import TableContentHeader from '../../../utils/components/table-content/TableContentHeader'
import AssignTicket from '../Modal/AssignTicket'
import ReplyTicket from '../Modal/ReplyTicket'
import toast from 'react-hot-toast'

const GET_TICKET_LIST = `${BASE_URL}/api/protect/getTypeTicketByUser`

const TicketsList = () => {
  const {
    pagination: {totalElement, page, size},
    updatePagination,
    handlePageChange,
    handlePagePerItem,
  } = usePaginationCounts(1, 10)

  const [searchTerm, setSearchTerm] = useState('')
  const [filteredTickets, setFilteredTickets] = useState<ITicket[]>([])
  const [assignTicketId, setAssignTicketId] = useState<number | null>(null)
  const [selectedTicketDetails, setSelectedTicketDetails] = useState<ITicketDetails | null>(null)

  const {data, isLoading, error} = useQuery({
    queryKey: ['ticketList', {page, size}],
    queryFn: async () => {
      const response = await axios.get(GET_TICKET_LIST, {params: {page, size}})
      const result = await response.data

      return {
        list: result.data,
        pagination: result.pagenationResponse,
      }
    },
  })

  const handleSelect = async (selectType: string, id: number) => {
    switch (selectType) {
      case 'assign':
        setAssignTicketId(id)
        break
      case 'reply':
        toast.loading('Getting ticket details..')
        const ticket = await getTicketDetailsById(id)
        setSelectedTicketDetails({...ticket, id})
        toast.dismiss()
        break
      default:
        break
    }
  }

  const resetAssignTicket = () => setAssignTicketId(null)
  const resetTicketDetails = () => setSelectedTicketDetails(null)

  useEffect(() => {
    if (data) {
      const keys: (keyof ITicket)[] = ['subject', 'user_name', 'status']
      const filtered = searchItems(data.list, searchTerm, keys)
      setFilteredTickets(filtered || [])
      // console.log(filtered)
      updatePagination(data.pagination)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, data])

  return (
    <>
      <h3 className='mb-4'>Tickets List</h3>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <div className='d-flex align-items-center position-relative my-1 w-500px'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            className='form-control form-control-solid ps-16 rounded-pill py-3 bg-transparent border border-gray-700'
            placeholder='Search'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div>
          <button
            className='btn btn-light-primary me-3'
            type='button'
            id='dropdownMenuButton'
            data-bs-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
          >
            <KTIcon iconName='exit-up' className='fs-2' />
            Export
          </button>
          <ul
            className='dropdown-menu menu menu-sub menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
            aria-labelledby='dropdownMenuButton'
          >
            <div className='menu-item px-3'>
              <a className='menu-link px-3'>CSV</a>

              <a className='menu-link px-3'>PDF</a>
            </div>
          </ul>
          <button
            type='button'
            className='btn btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
          >
            <KTIcon iconName='plus' className='fs-2' />
            New Ticket
          </button>
        </div>
      </div>

      <ListViewProvider isLoading={isLoading} data={filteredTickets}>
        <TableContentHeader size={size} handlePagePerItem={handlePagePerItem} />
        <TableContent
          isLoading={isLoading}
          error={error as Error}
          tableData={filteredTickets}
          tableColumn={ticketColumnList(handleSelect)}
        >
          {isLoading && !data ? (
            <div className='d-flex justify-content-center'>
              <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : (
            <TablePagination
              totalElement={totalElement}
              isLoading={isLoading}
              itemsPerPage={size}
              currentPage={page}
              handlePageChange={handlePageChange}
            />
          )}
        </TableContent>
      </ListViewProvider>

      <NewTicketModal />
      <AssignTicket assignTicketId={assignTicketId} onResetAssignTicket={resetAssignTicket} />
      <ReplyTicket ticketDetails={selectedTicketDetails} onResetTicketDetail={resetTicketDetails} />
    </>
  )
}

export default TicketsList
